/* LU27 cart: side cart <cart-drawer> + cart page. Updates by re-rendering the section. */
(function () {
  var R = window.routes || {};
  var CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var ADD = (R.cart_add_url || '/cart/add') + '.js';

  function parse(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    return d.querySelector(sel);
  }
  function setBubble(html) {
    if (!html) return;
    var src = parse(html, '.shopify-section');
    var dst = document.getElementById('cart-icon-bubble');
    if (src && dst) dst.innerHTML = src.innerHTML;
  }
  function apply(root, sections) {
    var id = root.dataset.section;
    if (sections && sections[id]) {
      var fresh = parse(sections[id], '[data-lc-inner]');
      var old = root.querySelector('[data-lc-inner]');
      if (fresh && old) old.replaceWith(fresh);
    }
    if (sections) setBubble(sections['cart-icon-bubble']);
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-LC': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function busy(root, on) { root.classList.toggle('is-busy', on); }
  function error(root, msg) {
    var e = root.querySelector('[data-lc-err]');
    if (e) { e.textContent = msg || 'Jokin meni vikaan. Yritä uudelleen.'; e.hidden = false; }
  }

  /* fresh cart HTML. A POST is never served from a cache, so a product added a moment ago always shows. */
  function refresh(root) {
    var id = root.dataset.section;
    var UPDATE = (R.cart_update_url || '/cart/update') + '.js';
    return post(UPDATE, { updates: {}, sections: [id, 'cart-icon-bubble'], sections_url: R.cart_url || '/cart' })
      .then(function (res) {
        if (res && res.sections && res.sections[id]) { apply(root, res.sections); return; }
        var url = (R.cart_url || '/cart') + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble&t=' + Date.now();
        return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (s) { apply(root, s); });
      })
      .catch(function () {});
  }
  function refreshAll() { document.querySelectorAll('[data-lc]').forEach(function (r) { refresh(r); }); }

  /* any add / change made by other theme code (product page, size finder, apps) refreshes the cart */
  if (window.fetch && !window.fetch.__lc) {
    var _fetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var mine = init && init.headers && init.headers['X-LC'];
      var p = _fetch.apply(this, arguments);
      if (!mine && /POST/i.test(method) && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) { if (r && r.ok) setTimeout(refreshAll, 0); }).catch(function () {});
      }
      return p;
    };
    wrapped.__lc = true;
    window.fetch = wrapped;
  }

  function bind(root) {
    if (root.__lc) return; root.__lc = true;
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-lc-qty]');
      var a = e.target.closest('[data-lc-add]');
      if (!q && !a) return;
      e.preventDefault();
      var sections = [root.dataset.section, 'cart-icon-bubble'];
      var req;
      busy(root, true);
      if (q) {
        var line = q.closest('[data-line]');
        req = post(CHANGE, { line: Number(line.dataset.line), quantity: Number(q.dataset.lcQty), sections: sections, sections_url: window.location.pathname });
      } else {
        req = post(ADD, { items: [{ id: Number(a.dataset.lcAdd), quantity: 1 }], sections: sections, sections_url: window.location.pathname });
      }
      req.then(function (res) {
        if (res.status && res.status >= 400) { error(root, res.description || res.message); return; }
        if (res.sections) apply(root, res.sections); else return refresh(root);
      })
        .catch(function () { error(root); })
        .finally(function () { busy(root, false); });
    });
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        bind(this);
        this.addEventListener('click', function (e) { if (e.target.closest('[data-lc-close]')) self.close(); });
        this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      }
      open(opener) {
        var self = this;
        this._opener = opener || document.activeElement;
        this.hidden = false;
        document.documentElement.classList.add('lc-lock');
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.classList.add('is-open'); }); });
        var panel = this.querySelector('.lc__panel');
        if (panel) setTimeout(function () { panel.focus(); }, 50);
        return refresh(this);
      }
      close() {
        var self = this;
        this.classList.remove('is-open');
        document.documentElement.classList.remove('lc-lock');
        setTimeout(function () { if (!self.classList.contains('is-open')) self.hidden = true; }, 300);
        if (this._opener && this._opener.focus) this._opener.focus();
      }
      /* used by the size finder and other theme code after an add to cart */
      renderContents() { return this.open(); }
      setActiveElement(el) { this._opener = el; }
    });
  }

  /* if another script already defined <cart-drawer>, give our element the same open/close behaviour */
  var own = customElements.get('cart-drawer');
  document.querySelectorAll('cart-drawer.lc').forEach(function (d) {
    if (own && d instanceof own && typeof d.renderContents === 'function' && d.renderContents.toString().indexOf('this.open') > -1) return;
    bind(d);
    d.addEventListener('click', function (e) { if (e.target.closest('[data-lc-close]')) d.close(); });
    d.open = function (opener) {
      d._opener = opener || document.activeElement;
      d.hidden = false;
      document.documentElement.classList.add('lc-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
      return refresh(d);
    };
    d.close = function () {
      d.classList.remove('is-open');
      document.documentElement.classList.remove('lc-lock');
      setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 300);
    };
    d.renderContents = function () { return d.open(); };
  });

  document.querySelectorAll('.lc--page[data-lc]').forEach(bind);

  /* cart icon opens the side cart (not on the cart page itself) */
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (!icon || /\/cart\/?$/.test(window.location.pathname)) return;
    var d = document.querySelector('cart-drawer.lc');
    if (!d) return;
    e.preventDefault();
    d.open(icon);
  });

  /* theme editor: show the side cart while its section is selected */
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target.querySelector && e.target.querySelector('cart-drawer.lc');
    if (d) d.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = e.target.querySelector && e.target.querySelector('cart-drawer.lc');
    if (d) d.close();
  });
  document.addEventListener('shopify:section:load', function (e) {
    var p = e.target.querySelector && e.target.querySelector('.lc--page[data-lc]');
    if (p) bind(p);
  });
})();
